import React, { useState } from 'react';
import * as PropTypes from 'prop-types';

const Search = ({ className, onSearchChange, placeholder }) => {
  const [searchValue, setSearchValue] = useState('');
  const onSearchValueChange = (v) => {
    setSearchValue(v);
    onSearchChange && onSearchChange(v.trim());
  };

  return (
    <div className="filterModule">
      <input
        className={className}
        type="text"
        onChange={(e) => onSearchValueChange(e.target.value)}
        placeholder={placeholder}
        value={searchValue}
      />
      <i
        className="fa fa-times-circle"
        onClick={() => onSearchValueChange('')}
      />
    </div>
  );
};

Search.propTypes = {
  className: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
export default Search;
